import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PdfLinkModule } from '@app/shared/pdf-link/pdf-link.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { TabsetModule } from '@app/shared/ux/tabs/tabset.module';
import { NewModalModule } from 'outshared-lib';
import { AansprakelijkheidInfoComponent } from './aansprakelijkheid-info/aansprakelijkheid-info.component';
import { CompleetlInfoComponent } from './compleet-info/compleet-info.component';
import { EigenaarsHuurderbelangInfoComponent } from './eigenaars-huurderbelang-info/eigenaars-huurderbelang-info.component';
import { GlasInfoComponent } from './glas-info/glas-info.component';
import { HomeCoverageInfoModalComponent } from './home-coverage-info-modal.component';
import { InboedelInfoComponent } from './inboedel-info/inboedel-info.component';
import { LagerEigenRisicoModalComponent } from './lager-eigen-risico-modal/lager-eigen-risico-modal.component';
import { MobieleElektronicaInfoComponent } from './mobiele-elektronica-info/mobiele-elektronica-info.component';
import { OpstalInfoComponent } from './opstal-info/opstal-info.component';
import { RouterLink } from '@angular/router';

/** @deprecated - this is moved to libs/shared/feature-coverage-modals */
@NgModule({
    imports: [
        CommonModule,
        NewModalModule,
        ListModule,
        TabsetModule,
        PdfLinkModule,
        RouterLink,
    ],
    declarations: [
        HomeCoverageInfoModalComponent,
        InboedelInfoComponent,
        OpstalInfoComponent,
        EigenaarsHuurderbelangInfoComponent,
        CompleetlInfoComponent,
        GlasInfoComponent,
        MobieleElektronicaInfoComponent,
        AansprakelijkheidInfoComponent,
        LagerEigenRisicoModalComponent,
    ],
    exports: [
        HomeCoverageInfoModalComponent,
        InboedelInfoComponent,
        OpstalInfoComponent,
        EigenaarsHuurderbelangInfoComponent,
        CompleetlInfoComponent,
        GlasInfoComponent,
        MobieleElektronicaInfoComponent,
        AansprakelijkheidInfoComponent,
        LagerEigenRisicoModalComponent,
    ],
})
export class HomeCoverageInfoModule {}
